import React from 'react';
import { PLANS } from '../../../config/settings';

const PlanSelection = ({ selectedPlan, onPlanSelect, onNext }) => {
  return (
    <div className="step-content">
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="text-center mb-4">
            <h3 className="mb-2">Scegli il piano più adatto a te</h3>
            <p className="text-muted">
              Seleziona il piano di abbonamento che preferisci
            </p>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        {PLANS.map((plan) => {
          const isSelected = selectedPlan.period === plan.period;
          return (
            <div
              key={plan.period}
              className="col-12 col-sm-6 col-lg-5 d-flex align-items-stretch mb-3 mb-md-4">
              <div
                className={`card shadow w-100 h-100 position-relative ${
                  plan.highlighted ? 'border-success' : ''
                } ${isSelected ? 'border-success' : ''} bg-light text-center`}
                onClick={() => onPlanSelect(plan)}
                style={{ cursor: 'pointer', borderWidth: isSelected ? 4 : 1 }}
                tabIndex={0}
                role="button"
                aria-pressed={isSelected}>
                {plan.highlighted && (
                  <div
                    className="position-absolute"
                    style={{ top: '-10px', right: '15px' }}>
                    <span className="badge badge-success px-3 py-1">
                      Più popolare
                    </span>
                  </div>
                )}

                <div className="card-header bg-white border-0 pb-0">
                  <h3 className="font-weight-bold mb-1">{plan.title}</h3>
                  <div className="text-muted mb-2">{plan.subtitle}</div>
                  <p className="mb-0">{plan.description}</p>
                </div>

                <div className="card-body pt-2 pb-0">
                  {plan.promoPrice ? (
                    <>
                      <div className="mb-1 small text-muted">Prezzo</div>
                      <div className="mb-2">
                        <span
                          className="text-muted text-decoration-line-through"
                          style={{ fontSize: '1rem' }}>
                          €{plan.price}
                        </span>
                      </div>
                      <div className="mb-1 font-weight-bold text-primary">
                        Prezzo lancio
                      </div>
                      <div
                        className="mb-2 d-flex justify-content-center align-items-center"
                        style={{ gap: '0.5rem' }}>
                        <span className="font-size-30 font-weight-bold text-primary mb-0">
                          €{plan.promoPrice}
                        </span>
                        <span className="badge badge-primary align-self-center">
                          Offerta
                        </span>
                        <span
                          className="text-muted align-self-end"
                          style={{ marginBottom: '0.5rem' }}>
                          /{plan.periodLabel}
                        </span>
                      </div>
                    </>
                  ) : (
                    <div
                      className="mb-2 d-flex justify-content-center align-items-center"
                      style={{ gap: '0.5rem' }}>
                      <span className="font-size-30 font-weight-bold text-primary mb-0">
                        €{plan.price}
                      </span>
                      <small
                        className="text-muted align-self-end"
                        style={{ marginBottom: '0.5rem' }}>
                        /{plan.periodLabel}
                      </small>
                    </div>
                  )}

                  <div className="d-grid mt-3">
                    {isSelected ? (
                      <button
                        className="btn btn-success btn-block font-weight-bold"
                        disabled>
                        <i className="bx bx-check mr-2"></i>
                        Selezionato
                      </button>
                    ) : (
                      <button
                        className="btn btn-outline-primary btn-block font-weight-bold"
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          onPlanSelect(plan);
                        }}>
                        Scegli questo piano
                      </button>
                    )}
                  </div>
                </div>

                <div className="card-footer bg-white border-0 pt-2">
                  <div className="text-left">
                    <h6 className="mb-2">Servizi inclusi:</h6>
                    <ul className="list-unstyled mb-0 text-muted small">
                      {plan.features.slice(0, 3).map((feature, index) => (
                        <li key={index} className="mb-1">
                          <i className="bx bx-check text-success mr-2"></i>
                          {feature}
                        </li>
                      ))}
                      {plan.features.length > 3 && (
                        <li className="mb-1 text-primary">
                          <i className="bx bx-plus mr-2"></i>e altri{' '}
                          {plan.features.length - 3} servizi
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-8">
          <div className="twitter-bs-wizard-pager-link d-flex justify-content-end mb-5">
            <button
              type="button"
              className="btn btn-primary btn-rounded waves-effect waves-light px-4"
              onClick={onNext}>
              Continua
              <i className="bx bx-chevron-right ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanSelection;
